import { render, staticRenderFns } from "./AppOrderItem.vue?vue&type=template&id=2ef0bf4e&scoped=true&"
import script from "./AppOrderItem.vue?vue&type=script&lang=js&"
export * from "./AppOrderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef0bf4e",
  null
  
)

export default component.exports